import React from "react";
import { CloseCrumb } from "./CloseCrumb";
export const BreadCrumb = (props) => {
    return (React.createElement("div", { onClick: () => props.handleClick(props.termId, props.active, props.hierarchy), className: `${props.active ? "flex" : "hidden"} bg-white text-charcoal justify-between py-1 cursor-pointer mr-4` },
        React.createElement("span", { className: "ml-6 mr-4 body small" }, props.name),
        React.createElement(CloseCrumb, null)));
};
